<div fxLayoutAlign="center start">
  <mat-card appearance="outlined" fxFlex="40" fxFlex.lt-lg="100" style="margin-top: 50px">
    <mat-card-header>
      <mat-card-title fxLayoutAlign="end end">
        <!-- reset -->
        <img src="assets/images/logo-mwi-new.jpg" style="width: 70%;  max-height: 150px"/>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content *ngIf="!shouldShowLoader()">
      <mat-vertical-stepper [linear]="false" #stepper>
        <mat-step state="reset">
          <ng-template matStepLabel="reset">
            <span>Password Reset</span>
          </ng-template>
          <form fxLayout="column" form="resetForm">
            <mat-form-field appearance="outline">
              <mat-label>Password</mat-label>
              <input
                matInput
                appNoWhiteSpace
                autocomplete="off"
                placeholder="Password"
                name="password"
                type="{{ passwordInputType }}"
                [formControl]="frmPassword"
                minlenght="9"/>
              <mat-icon matSuffix (click)="onClickPasswordIcon()"
              >visibility</mat-icon
              >
              <mat-error *ngIf="frmPassword.hasError('required')" style="color: #d32f2f">
                Password is required
              </mat-error>
              <mat-error *ngIf="frmPassword.hasError('minlength')" style="color: #d32f2f">
                Password minimum length is 9 characters
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Confirm password</mat-label>
              <input matInput
                     appNoWhiteSpace
                     autocomplete="off"
                     placeholder="Confirm Password"
                     name="confirmPassword"
                     type="{{ passwordInputType }}"
                     [formControl]="frmConfirmPassword"
                     minlenght="9"/>
              <mat-icon matSuffix (click)="onClickPasswordIcon()"
              >visibility</mat-icon
              >
              <mat-error *ngIf="frmConfirmPassword.hasError('required')" style="color: #d32f2f">
                Password confirmation required
              </mat-error>
              <mat-error *ngIf="frmConfirmPassword.hasError('minlength')" style="color: #d32f2f">
                Password minimum length is 9 characters
              </mat-error>
            </mat-form-field>

            <div fxLayout="row" style="margin-top: 15px">
              <button
                mat-raised-button
                type="button"
                color="primary"
                (click)="onSubmitPasswordReset()"
                [disabled]="shouldDisableSubmitButton()"
              >
                Reset password
              </button>
            </div>
          </form>
        </mat-step>
        <mat-step state="forgot_password">
          <ng-template matStepLabel="forgot_password">
            <span style="color: #d32f2f">
              I forgot my password / Account locked
            </span>
          </ng-template>
          <p>
            Please provide us with the username for the account that you would
            like to reset
          </p>
          <form fxLayout="column" form="resetForm">
            <mat-form-field appearance="outline">
              <mat-label>Username</mat-label>
              <input
                matInput
                autocomplete="off"
                placeholder="Username"
                name="resetUsername"
                [formControl]="frmResetUsername"
              />
              <mat-icon matSuffix>fingerprint</mat-icon>
              <mat-error
                *ngIf="frmResetUsername.hasError('required')"
                style="color: #d32f2f"
              >
                Username is required
              </mat-error>
            </mat-form-field>

            <div fxLayout="row" style="margin-top: 15px">
              <button
                mat-raised-button
                type="button"
                color="primary"
                (click)="onClickSubmitReset()"
                [disabled]="shouldDisableReset()"
              >
                Reset password
              </button>
            </div>
          </form>
        </mat-step>

        <!-- Icon overrides. -->
        <ng-template matStepperIcon="reset">
          <mat-icon>lock</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="forgot_password">
          <mat-icon>help</mat-icon>
        </ng-template>
      </mat-vertical-stepper>
    </mat-card-content>

    <mat-card-content
      fxLayout="column"
      *ngIf="shouldShowLoader()"
      fxLayoutAlign="center center"
      style="height: 240px"
    >
      <span fxFlex="100" style="padding-top: 30px">
        <mat-spinner></mat-spinner>
      </span>
      <span fxFlex="100">
        <h3>Communicating with the server...</h3>
      </span>
    </mat-card-content>
  </mat-card>
</div>
